import { getAPI } from "./axios-base";

export default class RestResourceEngineModel {
  getModels(params: { skip: number; limit: number }) {
    return getAPI.get("api/rest/v1/engine-models", {
      params: params
    });
  }
  getModel(id: string) {
    return getAPI.get(`api/rest/v1/engine-models/${id}`);
  }
  putModel(id: string, body: any) {
    return getAPI.put(`api/rest/v1/engine-models/${id}`, body);
  }
  getModelsByManufacturer(
    manufacturerId: string,
    params: {
      skip: number;
      limit: number;
    }
  ) {
    return getAPI.get(
      `api/rest/v1/engine-models/by-manufacturer/${manufacturerId}`,
      {
        params: params
      }
    );
  }
  getModelsByBrandAndYear(brandId: string, year: string) {
    return getAPI.get(
      `api/rest/v1/models/get-models-by-brand-year/${brandId}/${year}`
    );
  }
  getModelYearsByBrand(brandId: string) {
    return getAPI.get(`api/rest/v1/models/get-years-by-brand/${brandId}`);
  }
  postModel(body: any) {
    return getAPI.post(`api/rest/v1/engine-models`, body);
  }
}
